module.exports = __webpack_public_path__ + "components/country-flag/static/dm-f6bdd4e704f449c9c132dcf2cc726950.svg";